const windowsModifierKeys = {
  CONTROL: 'Ctrl',
  ALT: 'Alt',
};

const macModifierKeys = {
  CONTROL: 'Cmd',
  ALT: 'Opt',
};

export function getKeyShortcutByAgent(key: 'CONTROL' | 'ALT'): string {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('mac')) {
    return macModifierKeys[key];
  }
  return windowsModifierKeys[key];
}
